<template>
	<div class="end-run-buttons-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div class="buttons-section mb-3 flex-wrap" :class="[buttonsClass]">
			<div v-for="btn in buttonsOptions" :key="btn.id" class="">
				<PrimaryButton v-if="isPrimary(btn)" @click="onButtonClick(btn)">{{ btn.label }}</PrimaryButton>
				<OutlinedButton v-else class="secondary-button" @click="onButtonClick(btn)">{{ btn.label }}</OutlinedButton>
			</div>
		</div>
	</div>
</template>

<script>
import WidgetFieldMixin from '../WidgetFieldMixin';
import { downloadURI } from '@/utils/helpers';
import WidgetFormService from '../../../WidgetForm/WidgetFormService';

import DefaultWidgetField from '../DefaultWidgetField';

import { ACTION_TYPES, OPEN_URL_OPTIONS, BUTTONS_STYLES } from '../../FieldSettings/EndRunButtonsFieldSettings/end-run-field.const';

export default {
	name: 'EndRunButtonsField',
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
		configurationId: { type: Number },
	},
	components: {
		DefaultWidgetField,
	},
	mixins: [WidgetFieldMixin],
	data() {
		return { BUTTONS_STYLES };
	},
	computed: {
		buttonsOptions() {
			return this.fieldOptions.button_items;
		},
		buttonsClass() {
			const resultMap = {
				left: 'flex-start--center',
				center: 'flex-centerize',
				right: 'flex-end--center',
			};
			return resultMap[this.fieldOptions.alignment_style];
		},
	},
	methods: {
		onButtonClick(btn) {
			switch (btn.action) {
				case ACTION_TYPES.OPEN_URL:
					window.open(this.processInsertedData(btn.openUrl), btn.openUrlSelection === OPEN_URL_OPTIONS.OPEN_IN_NEW_TAB ? '_blank' : null);
					break;
				case ACTION_TYPES.DOWNLOAD_FILE:
					downloadURI(
						this.processInsertedData(btn.downloadFileUrl),
						'downloaded_file',
						() => this.$toast.success('Downloading file...'),
						() => this.$toast.error('Something went wrong...')
					);
					break;
				case ACTION_TYPES.CLOSE_MODAL:
					this.$emit('onCloseWidget');
					break;
				case ACTION_TYPES.RUN_FEATURE_AGAIN:
					this.$emit('restartRun');
					break;
				case ACTION_TYPES.COPY_TO_CLIPBOARD:
					navigator.clipboard
						.writeText(this.processInsertedData(btn.copyToClipboardText))
						.then(() => this.$toast.success('Copied text to clipboard!'))
						.catch(() => this.$toast.error('Something went wrong...'));
					break;
				default:
					break;
			}
		},
		processInsertedData(stringToProcess) {
			return WidgetFormService.processPreviousSteps(
				stringToProcess,
				this.previousSteps,
				this.replaceInsertDataStringDict,
				this.configurationsMappingBlocksUUIDs
			);
		},
		isPrimary(btn) {
			return [undefined, BUTTONS_STYLES.PRIMARY].includes(btn.buttonStyleSelection);
		},
	},
};
</script>

<style scoped lang="scss">
.end-run-buttons-field {
	.buttons-section {
		padding: 0 0 10px 0;

		> div {
			margin-left: 6px;
			margin-bottom: 3px;
		}

		::v-deep(.v-btn) {
			text-transform: none !important;

			&.outlined-button {
				border-color: #5d5cfc !important;
				color: #5d5cfc !important;
			}
		}
	}
}
</style>
